// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__TrdA3","textGray":"Pill_textGray__nuZkM"};